export default class Common {
  eventHandlers = [];

  constructor (template) {
    this.component = this.createComponent(template);
  }

  createComponent (template) {
    const div = document.createElement('div');
    div.innerHTML = template;
    return div.firstChild;
  }

  addEventListeners (listeners) {
    const addEventListener = (eventTarget, type, unboundListener, options) => {
      // Listener will be removed when this.removeEventListeners is called
      const listener = unboundListener.bind(this);
      this.eventHandlers.push({ eventTarget, type, listener });
      eventTarget.addEventListener(type, listener, options);
    };

    for (const listener of listeners) {
      addEventListener(...listener);
    }
  }

  removeEventListeners () {
    for (const { eventTarget, type, listener } of this.eventHandlers) {
      eventTarget.removeEventListener(type, listener);
    }
  }
}
